import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface TenantContext {
  id: string;
  name: string;
  slug: string;
}

interface TenantContextState {
  // The tenant being viewed/managed by super admin
  selectedTenant: TenantContext | null;
  // Set the tenant context
  setSelectedTenant: (tenant: TenantContext | null) => void;
  // Clear the tenant context
  clearSelectedTenant: () => void;
}

export const useTenantContextStore = create<TenantContextState>()(
  persist(
    (set) => ({
      selectedTenant: null,

      setSelectedTenant: (tenant) =>
        set({
          selectedTenant: tenant,
        }),

      clearSelectedTenant: () =>
        set({
          selectedTenant: null,
        }),
    }),
    {
      name: 'trackfleet-tenant-context',
    }
  )
);
